import useSWR from 'swr'
import type { KeyedMutator } from 'swr'
import { getBalanceInAccount } from 'api/billing'

// types
import type { AxiosResponseType, CommonError } from 'types/api/responses/common'
import type { AccountBalance } from 'types/api/responses/billing'

type Props = {
	accountId: number
}
type AccountBalanceResponse = AxiosResponseType<AccountBalance>
export default function useAccountBalance({
	accountId,
}: Props): {
	data: void | AccountBalanceResponse
	error: void | CommonError
	mutate: KeyedMutator<AccountBalanceResponse>
} {
	const { data, error, mutate } = useSWR<AccountBalanceResponse, CommonError>(
		[`/accounts/${accountId}/balance`, accountId],
		() => getBalanceInAccount({ accountId: Number(accountId) }),
	)

	return { data, error, mutate }
}
